import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ToastService } from '@shared/services/toast.service';

@Component({
  selector: 'app-toasts',
  standalone: true,
  imports: [],
  template: `
    @for (toast of toastService.toasts(); track toast) {
      <div class="toast show align-items-center border-0 mb-2"
           [class]="'toast show align-items-center border-0 mb-2 ' + (toast.classname || 'bg-dark text-white')"
           role="alert" aria-live="assertive" aria-atomic="true">
        <div class="d-flex">
          <div class="toast-body">
            {{ toast.message }}
          </div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto"
                  (click)="toastService.remove(toast)" aria-label="Close"></button>
        </div>
      </div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    'class': 'toast-container position-fixed bottom-0 end-0 p-3',
    'style': 'z-index: 1200'
  }
})
export class ToastContainerComponent {
  toastService = inject(ToastService);
}